// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import dateFormat from 'dateformat';
import { hideModal } from '../actions';
import { COLOR } from '../const';
import { postEveryjob, postEveryshop } from '../api/githubAPI';




const OrderDetail = (): JSX.Element => {

  const index = useSelector((state: any) => state.Modal.index)
  const order = useSelector((state: any) => state.Order.orders[index])
  const dispatch = useDispatch();
  // console.log('OrderDetail', order)

  useEffect(() => {
    if (order === undefined) {
      dispatch(hideModal())
    }

  }, [order])

  const datedilevery = new Date((order !== undefined) ? order.deliveryAt.dateDelivery : '');

  if (order === undefined) {
    return (<div className={styles.root}>
      <div className={styles.divHeader}>
        <div className={styles.divTitle}>

        </div>
      </div>
    </div>);
  }

  const handleShop = async () => {
    try {
      await Promise.all([
        postEveryshop(order.ref),
        dispatch(hideModal())
      ])
    } catch (err) {
      console.error(err)
    }
  }

  const handleJob = async () => {
    try {
      await Promise.all([
        postEveryjob(order.trackingNo),
        dispatch(hideModal())
      ])
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div className={styles.root}>
      <div className={styles.divHeader}>
        <div className={styles.divTitle}>
          <div>
            <div className={styles.textHeader}>DELIVERY DATE</div>
            <div className={styles.textTitle}>{dateFormat(datedilevery, "ddd dd-mm-yyyy")} {dateFormat(datedilevery, "H:MM")}</div>
          </div>
          <div>
            <div className={styles.textHeaderCenter}>TRACKING NO.</div>
            <div className={styles.textTitle}>{order.trackingNo}</div>
          </div>
        </div>
      </div>
      <div className={styles.divDetail}>

        <div className={styles.divItem}>
          <div className={styles.headerDetail}>ข้อมูลผู้ส่งสินค้า</div>
          <div className={styles.shopName}>{order.shopInformation.name}</div>
          <div className={styles.rowDetail}>
            <div className={styles.titleOrder}>เบอร์</div>
            <div className={styles.textDetail}>{order.shopInformation.mobile}</div>
          </div>
          <div className={styles.rowDetail}>
            <div className={styles.titleOrder}>ที่อยู่ร้าน</div>
            <div className={styles.textDetail}>{order.shopInformation.address}</div>
          </div>
          <div className={styles.columnDetail}>
            <div className={styles.titleOrder}>หมายเหตุ</div>
            <div className={styles.textColumnDetail}>{order.shopInformation.addressExtra}</div>
          </div>

        </div>

        <div className={styles.divItem}>
          <div className={styles.headerCus}>ข้อมูลผู้รับสินค้า</div>
          <div className={styles.cusName}>{order.contact.name}</div>
          <div className={styles.rowDetail}>
            <div className={styles.titleOrderCus}>เบอร์</div>
            <div className={styles.textDetailCus}>{order.contact.mobile}</div>
          </div>
          <div className={styles.rowDetail}>
            <div className={styles.titleOrderCus}>ที่อยู่ร้าน</div>
            <div className={styles.textDetailCus}>{order.address}</div>
          </div>
          <div className={styles.columnDetail}>
            <div className={styles.titleOrderCus}>หมายเหตุ</div>
            <div className={styles.textDetailCus}>{order.addressExtra}</div>
          </div>
        </div>

        {/* <div className={styles.flexRow}>
          <div className={styles.hedaerNote}>หมายเหตุ</div>
          <div className={styles.noteDetail}>ROUTE</div>
        </div> */}

        <div>
        </div>


      </div>
      <div className={styles.footer}>
        <div className={styles.buttonClose} onClick={() => { dispatch(hideModal()) }}>Close</div>
        <div className={styles.buttonShop} onClick={() => { handleShop() }}><i className="icon-shop" />SHOP</div>
        <div className={styles.buttonReroute} onClick={() => { handleJob() }}><i className="icon-truck" />NOW</div>
      </div>
    </div>
  );
}

const styles = {
  root: css`
  position: absolute;
  height: 100%;
  width: 600px;
  top: 0px;
  right: 0px;
  background: #fff;
  box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.13);
  border-radius: 23px 0px 0px 23px;
  `,
  button: css`
  position: absolute;
  bottom: 0px;
`,
  class: css`

  `,
  divHeader: css`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLOR['BLUE_DARK']};
  border-radius: 23px 0px 0px 0px;
  color:#ffffff;
  // font-family: system-ui;
  `,
  divTitle: css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding:15px 15px;
`,
  textHeader: css`
  color: #FFFFFF;
  font-weight: bold;
  font-size: 18px;
  padding-bottom:10px;
  `,
  textHeaderCenter: css`
  color: #FFFFFF;
  font-weight: bold;
  font-size: 18px;
  padding-bottom:10px;
  text-align: center;
  `,
  textTitle: css`
  color: #FFFFFF;
  font-size: 18px;
  `,
  divDetail: css`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
`,
  divItem: css`
  padding:15px 15px;
  // width: 100%;
  display: flex;
  flex-direction: column;
  background-color: rgba(253,181,19,0.05);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  &:nth-child(odd) {
    background-color:#ffffff;
  }
`,
  headerDetail: css`
  font-weight: bold;
  font-size: 20px;
  color: ${COLOR['DARK_2']};
  margin-bottom: 15px;
`,
  shopName: css`
  font-weight: bold;
  font-size: 24px;
  color: ${COLOR['DARK_2']};
  margin-bottom: 15px;
`,
  headerCus: css`
  font-weight: bold;
  font-size: 20px;
  color: ${COLOR['BLUE_DARK']};
  margin-bottom: 15px;
  `,
  cusName: css`
  font-weight: bold;
  font-size: 24px;
  color: ${COLOR['BLUE_DARK']};
  margin-bottom: 15px;
`,
  rowDetail: css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 15px;
  width: 100%;
`,
  columnDetail: css`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: 100%;
`,
  titleOrder: css`
  font-weight: bold;
  font-size: 18px;
  color: ${COLOR['DARK_2']};
  min-width: max-content;
`,
  textDetail: css`
  font-size: 18px;
  color: ${COLOR['DARK_2']};
  padding-left: 15px;
  `,
  textColumnDetail: css`
  font-size: 18px;
  color: ${COLOR['DARK_2']};
  padding-left: 15px;
  padding-top: 15px;
  `,
  titleOrderCus: css`
  font-weight: bold;
  font-size: 18px;
  color: ${COLOR['BLUE_DARK']};
  min-width: max-content;
`,
  textDetailCus: css`
  font-size: 18px;
  color: ${COLOR['BLUE_DARK']};
  padding-left: 15px;
  `,
  textColumnDetailCus: css`
  font-size: 18px;
  color: ${COLOR['BLUE_DARK']};
  padding-left: 15px;
  padding-top: 15px;
  `,
  flexRow: css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  `,
  hedaerNote: css`
  font-size: 20px;
  font-weight: bold;
  color: ${COLOR['BLUE_DARK']};
  // padding: 15px 0 15px 15px;
  `,
  noteDetail: css`
  font-size: 18px;
  color: ${COLOR['DARK_2']};
  text-align: left;
  width: 100%;
  padding:30px 0;
  `,
  footer: css`
  position: absolute;
  bottom: 0px;
  height: 92px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 23px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  `,
  buttonClose: css`
    cursor: pointer;
    position: absolute;
    line-height: 40px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 100px;
    height: 40px;
    background:  ${COLOR['BLUE_DARK']};
    border-radius: 13px;
    bottom: 20px;
    left: 30px;
    text-align: center;
  `,
  buttonReroute: css`
  position: absolute;
    line-height: 40px;
    color: #444966;
    font-size: 18px;
    font-weight: bold;
    width: 100px;
    height: 40px;
    background: #FDB513;
    border-radius: 13px;
    bottom: 20px;
    left: 470px;
    text-align: center;
    cursor: pointer;
    i:before{
      padding-right:10px;
    }
  `,
  buttonShop: css`
  position: absolute;
    line-height: 40px;
    color: #444966;
    font-size: 18px;
    font-weight: bold;
    width: 100px;
    height: 40px;
    background: #FDB513;
    border-radius: 13px;
    bottom: 20px;
    left: 360px;
    text-align: center;
    cursor: pointer;
    i:before{
      padding-right:10px;
    }
  `,
};

export default OrderDetail;